'use strict';

var react = require('@emotion/react');

const topAlignment = /*#__PURE__*/ react.css({
    alignItems: "baseline"
}, "label:label-Checkbox-web-stylestopAlignment", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvYXRvbXMvQ2hlY2tib3gvQ2hlY2tib3gud2ViLnN0eWxlcy50cyIsInNvdXJjZXMiOlsiL1VzZXJzL2lhbmNsYXJrZS9kZXYvYXZpYXJ5L3BhY2thZ2VzL2F2aWFyeS13ZWIvc3JjL2NvbXBvbmVudHMvYXRvbXMvQ2hlY2tib3gvQ2hlY2tib3gud2ViLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIjtcblxuZXhwb3J0IGNvbnN0IHRvcEFsaWdubWVudCA9IGNzcyh7XG4gIGFsaWduSXRlbXM6IFwiYmFzZWxpbmVcIixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUU0QiJ9 */");

exports.topAlignment = topAlignment;
//# sourceMappingURL=Checkbox.web.styles.cjs.map
